import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { environment } from '../../environments/environment';
import { BymeService } from './byme.service';
import { Project } from '../model/project';
import { Tools } from './tools';
import { DatasService } from './datas.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private customer:UserService, private byMeService:BymeService, private dataService: DatasService) { }

  getAllFromUser(userID: string) {

    return new Promise((resolve, reject) => {
      let _r = [];
      this.byMeService.callBymeApi({
      method: "GET",
      url: environment.byMe.webServiceURL + '/api/3/projects/user/' + userID + '?limit=500&noCache='+Math.random(),
    }).then((result:any)=>{
      let _counter:number = 0;
      if(result.rows.length === 0) resolve([]);
      for (let i = 0; i < result.rows.length; i++) {
        let _noCache:string = result.rows[i].dateUpdate.replace(/[\W]+/g,"");

          this.byMeService.callBymeApi({
          method: "GET",
          url: environment.byMe.webServiceURL + '/api/3/projects/' + result.rows[i].projectID + '/metadata/2'+ "?noCache="+_noCache
        }).then((metaData:any)=>{
          result.rows[i].search = Tools.removeAccents(result.rows[i].projectName.toLowerCase());
          result.rows[i].thumb = result.rows[i].bmProjURL.substring(0, result.rows[i].bmProjURL.length-43)+"images/thumbnails/thumbnail427x320.jpg?d="+_noCache;
          result.rows[i].distributionID = this.extractDistributionID(metaData.appData.bom);
          _r.push(Object.assign(new Project(), result.rows[i]));
            _counter++;
            if(_counter === result.rows.length) resolve(_r);
        }, (errorResponse: any) => {
          console.log(errorResponse);
          _counter++;
          if(_counter === result.rows.length) resolve(_r);
        });
      }
      });    
  });
}

  extractDistributionID(stringifiedBom:string):string{

    let _regexp = /distributionID\"\:\"([\w_-]+)\"/gi;
    let _exec = _regexp.exec(stringifiedBom);
    if(_exec) return _exec[1];
    // Hack : par defaut, on retourne Bathroom (pour l'instant c'est le seul qui ne transmet pas la stringifiedBom)
    return this.customer.country?.toLowerCase() == 'es' ? environment.byMe.bathroomDistribIdEs : environment.byMe.bathroomDistribIdPt;
  }

  
  getDetails(projectUUID: string, applicationId: number) {
    return new Promise((resolve, reject) => {
      this.byMeService.callBymeApi({
        method: "GET",
        url: environment.byMe.webServiceURL + '/api/3/projects/' + projectUUID + "?noCache="+Math.random()
      }).then((project:any)=>{
        this.byMeService.callBymeApi({
          method: "GET",
          url: environment.byMe.webServiceURL + '/api/3/projects/' + project.projectID + '/metadata/' + applicationId + "?noCache="+project.dateUpdate.replace(/[\W]+/g,"")
        }).then((metaData:any)=>{
          project.manualNotes = metaData.appData.manualNotes;

          if (metaData.appData.bom) {
            let bom = JSON.parse(metaData.appData.bom);
            if (bom.totalPrice) {
              project.totalPrice = bom.totalPrice.current;
            }
          }

          this.byMeService.callBymeApi({
            method: "GET",
            url: environment.byMe.webServiceURL + '/api/3/projects/' + project.projectID + '/media?limit=50&noCache='+project.dateUpdate.replace(/[\W]+/g,"")
          }).then((projectMedias:any)=>{
            project.medias = {
              render360: projectMedias.rows.filter(m=>m.typeMediaID===MEDIA_TYPE.RENDER_360),
              renderHQ: projectMedias.rows.filter(m=>m.typeMediaID===MEDIA_TYPE.RENDER_HQ),
              snapshot: projectMedias.rows.filter(m=>m.typeMediaID===MEDIA_TYPE.SNAPSHOT),
              plan2D: projectMedias.rows.filter(m=>m.typeMediaID===MEDIA_TYPE.PLAN_2D),
              thumbnail: projectMedias.rows.filter(m=>m.typeMediaID===MEDIA_TYPE.THUMBNAIL),
              crosscut: projectMedias.rows.filter(m=>m.typeMediaID===MEDIA_TYPE.CROSS_CUT),
            };

            resolve(project);
          }, (errorResponse: any) => {
            console.log("getProjectDetails/media.errorResponse", errorResponse);
            reject(errorResponse);
          });
        }, (errorResponse: any) => {
          console.log("getProjectDetails/metadata.errorResponse", errorResponse);
          reject(errorResponse);
        });
      }, (errorResponse: any) => {
        console.log("getProjectDetails/project.errorResponse", errorResponse);
        reject(errorResponse);
      });
    });
  }

  updateManualNotes(projectUUID: string, applicationId: number, htmlValue:string):Promise<void> {
    return new Promise((resolve, reject) => {
      this.byMeService.callBymeApi({
        method: "GET",
        url: environment.byMe.webServiceURL + '/api/3/projects/' + projectUUID + '/metadata/' + applicationId
      }).then((metaData:any)=>{

        let _currentMetaData = metaData.appData;
        _currentMetaData.manualNotes = htmlValue;
        
        this.byMeService.callBymeApi({
          method: "PUT",
          url: environment.byMe.webServiceURL + '/api/3/projects/' + projectUUID + '/metadata/' + applicationId,
          body:{ appData:_currentMetaData }
        }).then((response:any)=>{
          // console.log(response);
          resolve();
        }, (errorResponse: any) => {
          console.log("updateManualNotes/putMetadata.errorResponse", errorResponse);
          reject(errorResponse);
        });

      }, (errorResponse: any) => {
        console.log("updateManualNotes/metadata.errorResponse", errorResponse);
        reject(errorResponse);
      });
    });
  }

  updateNameAndDescription(projectUUID: string, projectName:string, projectHtmlDescription:string):Promise<void> {
    return new Promise((resolve, reject) => {
      this.byMeService.callBymeApi({
        method: "PUT",
        url: environment.byMe.webServiceURL + '/api/3/projects/' + projectUUID,
        body: {
          userID:this.customer.userDatas.hbmId,
          projectName: projectName,
          description: projectHtmlDescription
        }
      }).then((response:any)=>{
        // console.log(response);
        resolve();

      }, (errorResponse: any) => {
        console.log("updateManualNotes/putProject.errorResponse", errorResponse);
        reject(errorResponse);
      });
    });
  }

  duplicate(projectID:number, projectUUID: string, newProjectName:string):Promise<any>{

    return new Promise((resolve, reject) => {
      this.byMeService.callBymeApi({
        method: "PUT",
        url: environment.byMe.webServiceURL + '/api/3/actions/projects/' + projectID + "/duplicate",
        body: {
          userID: this.customer.userDatas.otherAccount ? this.customer.userDatas.otherAccount.hbmId : this.customer.userDatas.hbmId,
          projectName: newProjectName,
          projectUUID: projectUUID
        }
      }).then((response:any)=>{
        //console.log(response);
        this.dataService.insertProjectDuplicate(projectID, response.projectID).then((id) => {
            resolve(response);         
        })  
      }, (errorResponse: any) => {
        console.log("updateManualNotes/putDuplicateProject.errorResponse", errorResponse);
        reject(errorResponse);
      });
    });

  }


  delete(projectID:number):Promise<void>{

    return new Promise((resolve, reject) => {
      this.byMeService.callBymeApi({
        method: "DELETE",
        url: environment.byMe.webServiceURL + '/api/3/projects/' + projectID + "/user/"+this.customer.userDatas.hbmId,
      }).then((response:any)=>{
        // console.log(response);
        resolve();
      }, (errorResponse: any) => {
        console.log("updateManualNotes/putDeleteProject.errorResponse", errorResponse);
        reject(errorResponse);
      });
    });

  }

  lock(projectID:number):Promise<void>{

    return new Promise((resolve, reject) => {
      this.byMeService.callBymeApi({
        method: "PUT",
        url: environment.byMe.webServiceURL + '/api/3/actions/projects/' + projectID + "/lock",
      }).then((response:any)=>{
        // console.log(response);
        resolve();
      }, (errorResponse: any) => {
        console.log("LockProject.errorResponse", errorResponse);
        reject(errorResponse);
      });
    });
  }

  unlock(projectID:number):Promise<void>{

    return new Promise((resolve, reject) => {
      this.byMeService.callBymeApi({
        method: "PUT",
        url: environment.byMe.webServiceURL + '/api/3/actions/projects/' + projectID + "/unlock",
      }).then((response:any)=>{
        // console.log(response);
        resolve();
      }, (errorResponse: any) => {
        console.log("UnlockProject.errorResponse", errorResponse);
        reject(errorResponse);
      });
    });
  }
}

export enum MEDIA_TYPE {
  UNKNOWN,
  RENDER_360,
  RENDER_HQ,
  SNAPSHOT,
  PLAN_2D,
  THUMBNAIL,
  CROSS_CUT
}